import Modal from "react-bootstrap/Modal";
import sensorimg from '../Images/ic_sensor.png'
import ExitButton from './ExitButton'

function SensorModal(props){

    const handleClose = () => props.setVisibleModalType(4);


    
    return(
        <Modal show={props.visible} onHide={handleClose}
        size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered>
  <Modal.Header className="sensorModalHeader text-center">
  <Modal.Title className="sensorModalTitle w-100"><div className="row"><div className="col-md-1 col-2 col-sm-2"></div><div className="col-md-10 col-8 col-sm-8"><img className="modalicon" src={sensorimg} alt="" ></img></div><div className="col-md-1 col-2 col-sm-2"><ExitButton closeFunc={handleClose}/></div></div></Modal.Title>
  </Modal.Header>

  <Modal.Body>
  <div className="row">

  <div className="col-12 contentCol">
    
    <div className="sensorName">{props.infos.name}</div>
    <div className="sensorDesc">{props.infos.description}</div>
    <div className="iframe"><iframe src={props.infos.dashboard_link}  width="100%" height="400" title={props.infos.name}></iframe></div>
</div>


</div>
    
  </Modal.Body>

  
</Modal>
    )
}

export default SensorModal;